module.exports = __webpack_public_path__ + "static/media/solicitud_servicio_anexo_planes_y_tarifas_ecommerce_noviembre_2023.756e8622.pdf";